import {
  motion,
} from "framer-motion";

/*
  ============================================================
  PHOTOGRAPHY PREMIUM
  ThemeToggle
  ============================================================

  Kompakti Ivory / Noir -teemavaihto.

  Navbarissa ei näytetä teeman nimiä, jotta
  kontrolli ei vie turhaa vaakasuuntaista tilaa.

  - aurinko = Ivory / vaalea
  - kuu = Noir / tumma

  Painike vaihtaa suoraan seuraavaan käytössä
  olevaan teemaan.
*/

function SunIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle
        cx="12"
        cy="12"
        r="3.5"
        stroke="currentColor"
        strokeWidth="1.6"
      />

      <path
        d="
          M12 2.5V5
          M12 19V21.5
          M2.5 12H5
          M19 12H21.5
          M5.28 5.28L7.05 7.05
          M16.95 16.95L18.72 18.72
          M18.72 5.28L16.95 7.05
          M7.05 16.95L5.28 18.72
        "
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="
          M20.2 15.3
          A8.4 8.4 0 0 1
          8.7 3.8
          A8.5 8.5 0 1 0
          20.2 15.3Z
        "
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function ThemeToggle({
  theme,
  themes,
  setTheme,
  language = "fi",
}) {
  const themeOptions =
    Object.values(
      themes || {}
    );

  if (
    themeOptions.length < 2
  ) {
    return null;
  }

  const currentIndex =
    themeOptions.findIndex(
      (option) =>
        option.id === theme
    );

  const safeIndex =
    currentIndex >= 0
      ? currentIndex
      : 0;

  const nextIndex =
    (
      safeIndex + 1
    ) %
    themeOptions.length;

  const nextTheme =
    themeOptions[
      nextIndex
    ];

  const isNoir =
    theme === "noir";

  const nextLabel =
    nextTheme?.label?.[
      language
    ] ||
    nextTheme?.label?.fi ||
    nextTheme?.id ||
    "";

  const ariaLabel =
    language === "en"
      ? `Switch to ${nextLabel} theme`
      : `Vaihda teemaan ${nextLabel}`;

  return (
    <motion.button
      type="button"
      onClick={() =>
        setTheme(
          nextTheme.id
        )
      }
      whileTap={{
        scale: 0.94,
      }}
      aria-label={
        ariaLabel
      }
      title={
        ariaLabel
      }
      className="
        group
        relative
        flex
        h-10
        w-10
        shrink-0
        items-center
        justify-center
        rounded-full
        border
        border-border
        bg-surface/80
        text-text
        shadow-[0_1px_4px_rgba(0,0,0,0.04)]
        backdrop-blur-md
        transition-all
        duration-300

        hover:border-text
        hover:bg-canvas

        focus-visible:outline-none
        focus-visible:ring-2
        focus-visible:ring-text/30
        focus-visible:ring-offset-2
        focus-visible:ring-offset-canvas
      "
    >
      <motion.span
        key={theme}
        initial={{
          opacity: 0,
          rotate: -20,
          scale: 0.75,
        }}
        animate={{
          opacity: 1,
          rotate: 0,
          scale: 1,
        }}
        transition={{
          duration: 0.25,
        }}
        className="
          flex
          items-center
          justify-center
        "
      >
        {isNoir
          ? <MoonIcon />
          : <SunIcon />}
      </motion.span>

      <span
        className="
          pointer-events-none
          absolute
          inset-[4px]
          rounded-full
          border
          border-transparent
          transition-colors
          duration-300
          group-hover:border-border
        "
        aria-hidden="true"
      />
    </motion.button>
  );
}